import gsap from 'gsap'

import { utils, store } from '@/core'
import { lenis } from '../app'

const { qs, qsa } = utils
const { dom, device } = store

export default function () {
	const Menu = qs('.menu')
    const buttonMenu = qs('.burger')

    const tl = gsap.timeline({ paused: true })

    console.log('va')
    buttonMenu.addEventListener('click', () => {
        buttonMenu.classList.contains('open') ? Close() : Open()
    })

    function Open(){
        console.log(Menu, buttonMenu)

        tl.clear()
        .to(Menu,{ duration: .3, opacity: 1, pointerEvents:'initial', overflowY:'scroll', ease: 'expo.inOut' , onComplete: () => {
            Menu.classList.add('open')
            buttonMenu.classList.add('open')
            //lenis.stop()
        }})
        .restart()
    }
    function Close(){
        console.log('cierra')
       
        tl.clear()
        .to(Menu, { duration: .3, opacity:0, pointerEvents:'none', overflowY:'auto', ease: 'expo.inOut', onComplete: () => {
            Menu.classList.remove('open')
            buttonMenu.classList.remove('open')
            //lenis.start()
        }})
        .restart()
    }
}